export default __webpack_public_path__ + "static/media/W_Wasai.53b92860.svg";